import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import AddMemberToCollection from '@components/assign-team-member/AddMemberToCollection';
import { toastError } from '@components/Toast';
import TopDetails from '@components/TopDetails';

import { setCurrentActivePage } from '@store/actions/ActivePageAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import ApiClient from '@lib/apiClient';

import { changeDateFormat } from '@utils/Util';

const CollectionRequestDetails = ({ details }) => {
	const { id } = useParams();
	const dispatch = useDispatch();
	const navigate = useNavigate();

	useEffect(() => {
		if (details?.collectionApprovalStatus === 'APPROVED') {
			navigate(`/collections/view/${details?.collectionId}?tab=moodboard`, { replace: true });
		}
		dispatch(
			setCurrentActivePage({
				id: details?.collectionId,
				type: 'COLLECTION_CONVERSATION',
				pageType: 'DETAILS'
			})
		);
	}, [details]);

	const onApprove = async () => {
		try {
			dispatch(openLoader());
			const { data } = await ApiClient.POST('moodboardAction', {}, `${id}/approve`);
			dispatch(closeLoader());
			if (data) {
				navigate(`/collections/view/${details?.collectionId}?tab=moodboard`, { replace: true });
			}
		} catch ({ response }) {
			dispatch(closeLoader());
			if (response && response.data && response.data.message) {
				toastError(response.data.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

	const onCancel = async () => {
		try {
			dispatch(openLoader());
			const { data } = await ApiClient.POST('moodboardAction', {}, `${id}/cancel`);
			dispatch(closeLoader());
			if (data) {
				navigate('/buyer-requests');
			}
		} catch ({ response }) {
			dispatch(closeLoader());
			if (response && response.data && response.data.message) {
				toastError(response.data.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

	return (
		<div>
			<div className="bg-white">
				<div className="filter-container-top px-0 pt-0 pb-3 bg-gray">
					<div className="filters">
						<div className="sample-full-status">
							<ul className="common-list-component">
								<li>
									<img
										className="cursor-pointer"
										src={`${process.env.PUBLIC_URL}/icons/back-arrow-gray.svg`}
										alt="back"
										onClick={() => navigate(-1)}
									/>
									<span className="gray_dark_01 ml-2">
										{details?.title || details?.name}
									</span>
								</li>
								<li>
									<span>{details?.requestedBy} </span>
								</li>

								<li>
									<span>{changeDateFormat(details?.requestedAt, '', 'Do MMM')}</span>
								</li>
								<li>
									{details?.brandResponse ? (
										<span className="brand-common-design">
											{details?.brandResponse?.name}
										</span>
									) : (
										''
									)}
								</li>
							</ul>
						</div>
					</div>
					<div className="d-flex justify-content-end">
						<AddMemberToCollection collectionId={details?.collectionId} />
						{details?.collectionApprovalStatus === 'PENDING' && (
							<div className="ml-2">
								<button
									className="button gray-outline size32 mr-3"
									onClick={() => {
										onCancel();
									}}
								>
									<span>Cancel</span>
								</button>
								<button
									className="button approve size32 mr-3"
									onClick={() => {
										onApprove();
									}}
								>
									<span>Confirm</span>
								</button>
							</div>
						)}
					</div>
				</div>
			</div>
			<TopDetails
				type={'MOODBOARD'}
				moodboardId={details?.id}
				description={details?.description}
				documentLists={details?.fileList}
			/>
		</div>
	);
};

export default CollectionRequestDetails;
